import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Label, RadioSelect } from '@atlas/ui';

import Field from 'common/Form/Field';

const RadioSelectField = ({ field, onChange }) => {
  const { disabled, label, name, options: initialOptions, value: formValue } = field;
  const areFieldsAsync = useMemo(() => typeof initialOptions === 'function', [initialOptions]);
  const [options, setOptions] = useState(areFieldsAsync ? [] : initialOptions);
  useEffect(() => {
    if (areFieldsAsync) {
      (async () => {
        const loadedOptions = await initialOptions();

        setOptions(loadedOptions);
      })();
    }
  }, [areFieldsAsync, initialOptions]);
  const value = useMemo(
    () => options.find(option => option.value === formValue),
    [options, formValue],
  );
  const changeHandler = useCallback(
    option => {
      onChange(option.value);
    },
    [onChange],
  );

  return (
    <Field options={field}>
      {label && (
        <div className="ui__title">
          <Label message={label} />
        </div>
      )}

      <RadioSelect
        disabled={disabled}
        id={name}
        onChange={changeHandler}
        options={options}
        value={value}
      />
    </Field>
  );
};

export default RadioSelectField;
